const payment = {
    price: 'Prezzo',
    totalPrice: 'Prezzo totale',
    pricePerPerson: 'a persona',
    // Payment Buttons
    bookTrip: 'Prenota "{tripName}"',
    deposit: 'Acconto: (da pagare ora)',
    balance: 'Saldo: (da pagare un mese prima del viaggio)',
    payDeposit: 'Paga Acconto (€{amount})',
    payBalance: 'Paga Saldo (€{amount})',
    // Simple labels without placeholders
    depositLabel: 'Acconto',
    balanceLabel: 'Saldo',
    processing: 'Elaborazione...',
    securityInfo: {
        title: 'Informazioni sulla Sicurezza',
        stripeSecure: '• I pagamenti sono gestiti in modo sicuro da Stripe',
        noCardStorage: '• Non memorizziamo i dati della tua carta',
        balanceDue: '• Il saldo dovrà essere pagato un mese prima del viaggio',
        emailConfirmation: '• Riceverai una email di conferma dopo ogni pagamento'
    },
    tripFullMessage: 'Il viaggio è completo. Non è possibile effettuare il pagamento dell\'acconto.',
    tripFull: 'Viaggio Completo',
    cannotPayTripFull: 'Impossibile pagare, il viaggio è già completo',

    // Payment Success
    paymentSuccess: 'Pagamento completato con successo!',
    trip: 'Viaggio',
    paymentType: 'Tipo Pagamento',
    amount: 'Importo',
    nextStep: 'Prossimo passo: Il saldo dovrà essere pagato un mese prima del viaggio. Riceverai una notifica quando sarà il momento di completare il pagamento.',
    viewTrip: 'Vedi Viaggio',
    viewBookings: 'Vedi le mie prenotazioni',
    close: 'Chiudi',

    // User Bookings
    yourBookings: 'Le tue prenotazioni',
    loadingBookings: 'Caricamento prenotazioni...',
    noBookings: 'Non hai ancora prenotazioni',
    noBookingsMessage: 'Non hai ancora effettuato nessuna prenotazione.',
    bookingError: 'Errore nel caricamento delle prenotazioni',
    retry: 'Riprova',
    tripDate: 'Data viaggio',
    bookedOn: 'Prenotato il',
    toBeConfirmed: 'Da confermare',
    paymentStatus: 'Stato pagamenti',
    total: 'Totale',
    depositPaid: 'Pagato',
    balancePaid: 'Pagato',
    depositPending: 'In attesa',
    balancePending: 'In attesa',
    depositToPayNow: '(da pagare ora)',
    balanceToPayBeforeTrip: '(da pagare un mese prima del viaggio)',
    depositFailed: 'Fallito',
    balanceFailed: 'Fallito',
    confirmed: 'Confermato',
    pending: 'In attesa',
    cancelled: 'Cancellato',

    // Payment Return
    verifyingPayment: 'Verifica del pagamento in corso...',
    paymentVerificationError: 'Errore nella verifica del pagamento',
    paymentCancelled: 'Pagamento annullato',
    verifying: 'Verificando il pagamento...',
    missingSessionId: 'ID sessione mancante. Pagamento non valido.',
    paymentCompleted: 'Pagamento Completato!',
    paymentSuccessMessage: 'Il tuo pagamento è stato elaborato con successo. Riceverai una email di conferma a breve.',
    backToHome: 'Torna alla Home',
    goToAccount: 'Vai al Mio Account',
    paymentError: 'Errore nel Pagamento',
    contactSupport: 'Contattaci per Supporto',
    invalidSession: 'Sessione non valida',

    // Payment Error
    paymentFailed: 'Pagamento Fallito',
    paymentFailedMessage: 'Ci dispiace, ma il tuo pagamento non è potuto essere elaborato. Riprova o contattaci se il problema persiste.',
    paymentDetails: 'Dettagli Pagamento',
    errorDetails: 'Dettagli Errore',
    whatToDo: 'Cosa fare:',
    checkCardDetails: 'Verifica che i dati della carta siano corretti',
    ensureSufficientFunds: 'Assicurati di avere fondi sufficienti',
    tryDifferentCard: 'Prova un metodo di pagamento diverso',
    contactSupportIfNeeded: 'Contattaci se continui ad avere problemi',
    retryPayment: 'Riprova Pagamento',

    // Insufficient Spots Error
    insufficientSpots: 'Ci Dispiace, Troppo Tardi!',
    insufficientSpotsMessage: 'Ci dispiace, ma non ci sono più posti disponibili per questo viaggio. Sono rimasti solo {availableSpots} posti.',
    insufficientSpotsDetails: 'Purtroppo, altri viaggiatori hanno completato le loro prenotazioni mentre stavi elaborando il pagamento. Controlla i nostri altri viaggi disponibili o contattaci per assistenza.',

    // Refund
    refund: {
        requestTitle: 'Richiesta Rimborso',
        requestDescription: 'Puoi richiedere un rimborso solo per il pagamento finale (saldo). L\'acconto non può essere rimborsato.',
        trip: 'Viaggio',
        amount: 'Importo',
        reasonLabel: 'Motivo del rimborso',
        reasonPlaceholder: 'Spiega perché stai richiedendo un rimborso...',
        reasonRequired: 'Fornisci un motivo per la richiesta di rimborso',
        submitRequest: 'Invia Richiesta',
        requestSubmitted: 'Richiesta di rimborso inviata con successo. Riceverai una email di conferma a breve.',
        requestError: 'Errore nell\'invio della richiesta di rimborso. Riprova.',
        requestStatus: 'Richiesta di rimborso inviata e in elaborazione.',
        alreadyRequested: 'Rimborso già richiesto',
        requestPending: 'Richiesta di rimborso in attesa',
        requestApproved: 'Richiesta di rimborso approvata',
        requestRejected: 'Richiesta di rimborso rifiutata',
        requestProcessed: 'Richiesta di rimborso elaborata',
        refundRequests: 'Richieste di rimborso',
        refundRequestBalance: 'Richiesta rimborso saldo (€{amount})',
        refundRequestSentOn: 'Inviata il: {date}',
        refundRequestProcessedOn: 'Elaborata il: {date}',
        refundRequestNotes: 'Note: {notes}',
        refundDepositNotAvailable: 'Il rimborso dell\'acconto non è disponibile. Solo il saldo può essere rimborsato.'
    },

    // Resume Payment
    resumeDepositPayment: 'Riprendi Pagamento Acconto',
    resumeBalancePayment: 'Paga quota finale',
    paymentPending: 'Pagamento in Corso...',
    payDepositFirst: 'Paga prima l\'acconto',

    // Account Page
    yourPayments: 'I tuoi pagamenti',
    totalPaid: 'Totale pagato',
    notPaid: 'Non pagato',
    inProgress: 'In attesa',
    completed: 'Completato',
    partiallyPaid: 'Parzialmente pagato',
    actions: 'Azioni',
    accountActions: 'Azioni Account',
    noPaymentsFound: 'Nessun pagamento trovato',
    paymentLoadingError: 'Errore nel caricamento dei pagamenti',

    // Trip Details Booking Section
    bookThisTrip: 'Prenota questo viaggio',
    completeBooking: 'Completa la prenotazione pagando l\'acconto. Il saldo dovrà essere pagato un mese prima del viaggio.',
    depositInfo: 'L\'acconto è del 30% del prezzo totale',
    balanceInfo: 'Il saldo (70%) deve essere pagato un mese prima del viaggio',
    importantInfo: {
        title: 'Informazioni importanti',
        depositPercent: '• Acconto da versare alla prenotazione',
        balancePercent: '• Il saldo deve essere pagato un mese prima del viaggio',
        stripeSecure: '• I pagamenti sono gestiti in modo sicuro da Stripe',
        noCardStorage: '• Non memorizziamo i dati della tua carta di credito',
        emailConfirmation: '• Riceverai una email di conferma dopo ogni pagamento'
    }
};

export default payment;
